import firebase from 'firebase/app'
import "firebase/auth";


const app = firebase.initializeApp({
  apiKey: "AIzaSyCU2PpRYKvoGElLRJYX22dgILdlI0XjPLM",
   authDomain: "auth-dev-6fa29.firebaseapp.com",
   projectId: "auth-dev-6fa29",
   storageBucket: "auth-dev-6fa29.appspot.com",
   messagingSenderId: "83501757355",
   appId: "1:83501757355:web:bc03c2a003d368cecbd8ee"
});

export default app;
